import { memo } from 'react';
import { ModalExtendedProps } from '@bonanza-social/navigation';
import StatusModal from '../components/StatusModal/StatusModal';
import StatusPromotion from '../components/StatusPromotion/StatusPromotion';

function StatusPromotionModal({ close }: ModalExtendedProps) {
  return (
    <StatusModal close={close}>
      <StatusPromotion flex={1} onButtonPress={close} />
    </StatusModal>
  );
}

export default memo(StatusPromotionModal);
